import { FC } from "react";
import { Path, Svg, SvgProps } from "react-native-svg";

const PdPaper: FC<SvgProps> = (props) => (
  <Svg viewBox="0 0 32 32" fill="none" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 6C7.67157 6 7 6.67157 7 7.5C7 8.32843 7.67157 9 8.5 9H9.5C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6H8.5ZM9.5 7H8.5C8.22386 7 8 7.22386 8 7.5C8 7.77614 8.22386 8 8.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7Z"
      fill="currentColor"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 11.5C7 10.6716 7.67157 10 8.5 10H9.5C10.3284 10 11 10.6716 11 11.5C11 12.3284 10.3284 13 9.5 13H8.5C7.67157 13 7 12.3284 7 11.5ZM8.5 11H9.5C9.77614 11 10 11.2239 10 11.5C10 11.7761 9.77614 12 9.5 12H8.5C8.22386 12 8 11.7761 8 11.5C8 11.2239 8.22386 11 8.5 11Z"
      fill="currentColor"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 14C7.67157 14 7 14.6716 7 15.5C7 16.3284 7.67157 17 8.5 17H9.5C10.3284 17 11 16.3284 11 15.5C11 14.6716 10.3284 14 9.5 14H8.5ZM9.5 15H8.5C8.22386 15 8 15.2239 8 15.5C8 15.7761 8.22386 16 8.5 16H9.5C9.77614 16 10 15.7761 10 15.5C10 15.2239 9.77614 15 9.5 15Z"
      fill="currentColor"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 19.5C7 18.6716 7.67157 18 8.5 18H9.5C10.3284 18 11 18.6716 11 19.5C11 20.3284 10.3284 21 9.5 21H8.5C7.67157 21 7 20.3284 7 19.5ZM8.5 19H9.5C9.77614 19 10 19.2239 10 19.5C10 19.7761 9.77614 20 9.5 20H8.5C8.22386 20 8 19.7761 8 19.5C8 19.2239 8.22386 19 8.5 19Z"
      fill="currentColor"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 22C7.67157 22 7 22.6716 7 23.5C7 24.3284 7.67157 25 8.5 25H9.5C10.3284 25 11 24.3284 11 23.5C11 22.6716 10.3284 22 9.5 22H8.5ZM9.5 23H8.5C8.22386 23 8 23.2239 8 23.5C8 23.7761 8.22386 24 8.5 24H9.5C9.77614 24 10 23.7761 10 23.5C10 23.2239 9.77614 23 9.5 23Z"
      fill="currentColor"
    />
    <Path
      d="M13 7C12.7239 7 12.5 7.22386 12.5 7.5C12.5 7.77614 12.7239 8 13 8H24C24.2761 8 24.5 7.77614 24.5 7.5C24.5 7.22386 24.2761 7 24 7H13Z"
      fill="currentColor"
    />
    <Path
      d="M12.5 11.5C12.5 11.2239 12.7239 11 13 11H24C24.2761 11 24.5 11.2239 24.5 11.5C24.5 11.7761 24.2761 12 24 12H13C12.7239 12 12.5 11.7761 12.5 11.5Z"
      fill="currentColor"
    />
    <Path
      d="M13 15C12.7239 15 12.5 15.2239 12.5 15.5C12.5 15.7761 12.7239 16 13 16H24C24.2761 16 24.5 15.7761 24.5 15.5C24.5 15.2239 24.2761 15 24 15H13Z"
      fill="currentColor"
    />
    <Path
      d="M12.5 19.5C12.5 19.2239 12.7239 19 13 19H24C24.2761 19 24.5 19.2239 24.5 19.5C24.5 19.7761 24.2761 20 24 20H13C12.7239 20 12.5 19.7761 12.5 19.5Z"
      fill="currentColor"
    />
    <Path
      d="M13 23C12.7239 23 12.5 23.2239 12.5 23.5C12.5 23.7761 12.7239 24 13 24H24C24.2761 24 24.5 23.7761 24.5 23.5C24.5 23.2239 24.2761 23 24 23H13Z"
      fill="currentColor"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3C5.44772 3 5 3.44772 5 4V28C5 28.5523 5.44772 29 6 29H26C26.5523 29 27 28.5523 27 28V4C27 3.44772 26.5523 3 26 3H6ZM26 4H6V28H26V4Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdPaper;
